<template>
    <div class="instructors">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card" v-if="instructors">

                        <div class="card-header border-0">
                            <div class="row">
                                <div class="col-6">
                                    <h3 class="mb-0 text-uppercase">{{ cohort.name }}: {{ $t('reports.cohort-instructors') }}</h3>
                                </div>
                                <div class="col-6 text-right">
                                    <el-dropdown trigger="click" @command="openReport($event)">
                                        <base-button type="primary" class="dropdown-toggle btn-sm mr-0" @click.prevent.stop="">
                                            <i class="tim-icons icon-line-chart mr-1"></i> {{ $t('common.reports') }}
                                        </base-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="learners">
                                                {{ $t('reports.cohort-learners') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="instructors">
                                                {{ $t('reports.cohort-instructors') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="degrees">
                                                {{ $t('reports.cohort-degrees') }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>

                        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('dashboard.no-instructor') }}</p>

                        <div v-if="!empty">
                            
                            <table-control :search="true" v-model="search"></table-control>

                            <el-table class="table-responsive table-flush"
                                    header-row-class-name="thead-light"
                                    :data="filteredInstructors">

                                <el-table-column width="72">
                                    <template v-slot="{row}">
                                        <span class="avatar rounded-circle">
                                            <img :src="row.avatar">
                                        </span>
                                    </template>
                                </el-table-column>

                                <el-table-column width="200">
                                    <template v-slot="{row}">
                                        <h4 class="mb-0">
                                            {{row.name}}
                                        </h4>
                                        <small v-if="row.owner">
                                            {{ row.owner.name }}
                                        </small>
                                        <small v-if="row.entity">
                                            / {{ row.entity.name }}
                                        </small>
                                        <br>
                                        <badge type="primary" v-if="row.pivot && row.pivot.referent">
                                            {{ $t('dashboard.referent') }}
                                        </badge>

                                    </template>
                                </el-table-column>

                                <el-table-column align="center" class-name="degree" v-for="(registration, index) in registrations" :key="index" width="120">
                                    <div slot="header">
                                        {{ registration.degree.name }}
                                    </div>
                                    <template v-slot="{row}">
                                        <div :class="{'unregistered': unregistered(row, registration)}" v-if="sessionsCount(row, registration)">
                                            <strong>{{ sessionsCount(row, registration) }}</strong> {{ $t('reports.sessions') }}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                instructors: null,
                registrations: null,
                cohort: {},
                search: '',
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/reports/cohorts/'+to.params.cohortId+'/instructors')
            .then(resp => {
                next(vm => {
                    vm.instructors = resp.data.data
                    vm.registrations = resp.data.included.registrations
                    vm.cohort = resp.data.included.cohort
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('reports.cohorts'),
                        route: '/astral/ui/reports/cohorts'
                    },
                    {
                        name: this.cohort.name,
                    },
                    {
                        name: this.$t('reports.cohort-instructors'),
                    },
                ]
            },

            empty() {
                return this.instructors && this.instructors.length == 0 && !this.search
            },

            filteredInstructors() {
                // Search filter.
                let instructors = this.instructors.filter(instructor => !this.search
                    || instructor.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                instructors = instructors.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
                return instructors;
            },
        },

        methods: {

            state(instructor, registration) {
                return instructor.state && instructor.state[registration.id]
            },

            sessionsCount(instructor, registration) {
                const state = this.state(instructor, registration)
                return state ? state.sessions_count : 0
            },

            unregistered(instructor, registration) {
                const state = this.state(instructor, registration)
                return state ? state.unregistered : 0
            },

            openReport(report) {
                this.$router.push({ name: 'report-cohort-' + report, params: { cohortId: this.cohort.id } })
            },
        }
    }
</script>

<style scoped>

    .instructors >>> th,
    .instructors >>> td {
        padding-right: 0;
    }
    .instructors >>> td.degree {
        padding-right: .5rem;
        padding-left: .5rem;
    }
    .instructors >>> td:has(.unregistered) {
        background-color: #f6f9fc !important;
    }
    .instructors >>> .table-control form {
        width: 100%;
    }
    
</style>
